import getLocalTrigger from "../../../utils/get-local-trigger";
import { G_timeouts } from "../../../utils/globals/globals";
import run from "../../animate/run";

/**
 * initialize `timeout` triggers
 * @param {Map<TorusElement, MainClassProps> | null} [targets]
 */
const initTimeout = (targets) => {
  /** Get all "animate" triggers */
  const timeouts = getLocalTrigger("timeout", targets);

  /** Loop trough timeout triggers and fire the timeout event */
  for (const [main, names] of timeouts) {
    /** Multiple timeout trigger names */
    for (const name of names) {
      const trigger = /** @type {TriggerProps} */ (main.store.get(name));

      const parameters = /** @type {DefaultTriggerParametersProps} */ (
        trigger.get("parameters")
      );

      const start = /** @type {Number} */ (
        /** @type {unknown} */ (parameters.get("start")?.get("v_value"))
      );
      const end = /** @type {Number} */ (
        /** @type {unknown} */ (parameters.get("end")?.get("v_value"))
      );
      const lasts = /** @type {Number} */ (
        /** @type {unknown} */ (parameters.get("lasts")?.get("v_value"))
      );

      const startTimeout = setTimeout(() => {
        run(main.events.get(`timeoutenter:${name}`), "enter");

        clearTimeout(startTimeout);
        G_timeouts.delete(startTimeout);

        if (end) {
          const endTimeout = setTimeout(() => {
            run(main.events.get(`timeoutleave:${name}`), "leave");

            clearTimeout(endTimeout);
            G_timeouts.delete(endTimeout);
          }, end - start);

          G_timeouts.add(endTimeout);
        }

        if (lasts) {
          const lastsTimeout = setTimeout(() => {
            run(main.events.get(`timeoutleave:${name}`), "leave");

            clearTimeout(lastsTimeout);
            G_timeouts.delete(lastsTimeout);
          }, lasts);

          G_timeouts.add(lastsTimeout);
        }
      }, start);

      G_timeouts.add(startTimeout);
    }
  }
};

export default initTimeout;
